import React, {useEffect, useRef, useCallback, useState} from 'react';
import {useLocation } from 'react-router-dom';
import TreeView from 'devextreme-react/tree-view';
import {navigation} from '../../app-navigation';
import {useScreenSize} from '../../utils/media-query';
import './SideNavigationMenu.scss';
import * as events from 'devextreme/events';
import {useConversations} from '../../contexts/conversation';

export default function SideNavigationMenu(props) {
  const location = useLocation();
  const { conversations, selectedId } = useConversations();

  const {children, selectedItemChanged, openMenu, compactMode, onMenuReady} = props;
  const {isLarge} = useScreenSize();
  const [menuItems, setMenuItems] = useState([]);

  const treeViewRef = useRef(null);
  const wrapperRef = useRef();

  const getWrapperRef = useCallback((element) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', (e) => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (location.pathname !== undefined) {
      treeView.selectItem(location.pathname);
      treeView.expandItem(location.pathname);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [location, compactMode]);

  useEffect(() => {
    // update menu when conversations or selected changes
    (() => setMenuItems(mi => mi.map(node =>
        node.id !== 'my-conversations'
            ? node
            : {
              ...node,
              disabled: !conversations.length,
              items: conversations.map(c => ({
                path: `/home/${c.id}`,
                id: c.uuid,
                text: c.summary,
                icon: 'message',
                selected: c.id === selectedId}))
            })
    ))();
  }, [conversations, selectedId]);

  useEffect(() => {
    setMenuItems(navigation.map(item =>
          ({...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path})))
    }, [isLarge]);

  return (
    <div className={'side-navigation-menu'} ref={getWrapperRef}>
      {children}
      <div className={'menu-container'}>
        <TreeView
          ref={treeViewRef}
          dataSource={menuItems}
          keyExpr="path"
          selectionMode="single"
          focusStateEnabled={false}
          expandEvent="click"
          onItemClick={selectedItemChanged}
          selectByClick={true}
          onContentReady={onMenuReady}
          width="100%"
        />
      </div>
    </div>
  );
}
